module.exports = __webpack_public_path__ + "img/realtime.76f7e2fe.jpg";